import { getErrorMessage } from 'application/util/error.util';

import './email-ingest-token-modal.style.sass';
import template from './email-ingest-token-modal.tpl.pug';

const INBOUND_EMAIL_DOMAIN = 'inbox.dollarbird.co';

class EmailIngestTokenModalController {
    /* @ngInject */
    constructor($q, $window, emailIngestTokenService, modalService, notificationService) {
        this.$q = $q;
        this.$window = $window;
        this.emailIngestTokenService = emailIngestTokenService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.loading = true;

        return this.reload().finally(() => {
            this.loading = false;
        });
    }

    reload() {
        return this.emailIngestTokenService.getActiveByTeamId(this.teamId).then((token) => {
            this.token = token;
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load the inbound email address. Please try again later.`));
            return this.$q.reject(result);
        });
    }

    enable() {
        this.loading = true;

        return this.emailIngestTokenService.create(this.teamId).then((token) => {
            this.token = token || null;

            if (!this.token) {
                return this.reload();
            }

            return null;
        }).catch((result) => {
            if (result && result.data && result.data.error === 'EMAIL_INGEST_TOKEN_CONFLICT') {
                return this.reload();
            }

            this.notificationService.showError(getErrorMessage(result, `We were not able to enable your inbound email address. Please try again later.`));
            return null;
        }).finally(() => {
            this.loading = false;
        });
    }

    remove() {
        if (!this.token || !this.token.id) {
            return null;
        }

        return this.modalService.open({
            component: 'dbAConfirmModal',
            bindings: {
                title: 'Delete email address',
                message: [
                    `Deleting this address cannot be undone.`,
                    `Are you still sure about it?`
                ],
                primaryButton: [
                    `Delete`,
                    `Deleting...`
                ],
                onClose: () => {
                    this.loading = true;

                    return this.emailIngestTokenService.remove(this.token.id).then(() => {
                        this.token = null;
                    }).catch((result) => {
                        this.notificationService.showError(getErrorMessage(result, `We were not able to delete your inbound email address. Please try again later.`));
                        return this.$q.reject(result);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }).catch(() => null);
    }

    getAddress() {
        if (!this.token || !this.token.token) {
            return null;
        }

        return `${this.token.token}@${INBOUND_EMAIL_DOMAIN}`;
    }

    copyAddress() {
        const address = this.getAddress();
        if (!address) {
            return this.$q.resolve();
        }

        return this.$q.when(this.writeTextToClipboard(address)).then(() => {
            this.notificationService.showInfo('Email address copied.');
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to copy the email address. Please try again.`));
        });
    }

    writeTextToClipboard(text) {
        const clipboard = this.$window.navigator && this.$window.navigator.clipboard;
        if (clipboard && this.$window.isSecureContext) {
            return clipboard.writeText(text);
        }

        return this.$q((resolve, reject) => {
            const node = this.$window.document.createElement('textarea');
            node.value = text;
            node.setAttribute('readonly', '');
            node.style.position = 'fixed';
            node.style.top = '-9999px';

            this.$window.document.body.appendChild(node);
            node.focus();
            node.select();

            const copied = this.$window.document.execCommand('copy');
            this.$window.document.body.removeChild(node);

            return copied ? resolve() : reject('Clipboard copy failed.');
        });
    }

    dismiss() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbAEmailIngestTokenModal',
    template: template(),
    controller: EmailIngestTokenModalController,
    bindings: {
        teamId: '<',
        teamName: '<',
        title: '@?',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/email-ingest-token-modal/email-ingest-token-modal.cmpt.js